(() => {
  'use strict';

  const MOBILE_QUERY = '(max-width: 749px)';

  function initStickyPurchaseBar(root = document) {
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('.dv-sticky-atc')) return;

    const mainButton = root.querySelector('.product-form__submit, button[name="add"]');
    const title = root.querySelector('h1.product__title, .product__title h1, h1');
    const firstPrice = root.querySelector('[id^="price-"] .price, .product__info-container .price');
    if (!mainButton || !title || !firstPrice) return;

    const bar = document.createElement('aside');
    bar.className = 'dv-sticky-atc';
    bar.dataset.visible = 'false';
    bar.setAttribute('aria-label', 'Flýtikaup');
    bar.innerHTML = `
      <div class="dv-sticky-atc__summary">
        <span class="dv-sticky-atc__title"></span>
        <span class="dv-sticky-atc__price"></span>
      </div>
      <button class="dv-sticky-atc__button" type="button"></button>
    `;
    document.body.appendChild(bar);

    const stickyTitle = bar.querySelector('.dv-sticky-atc__title');
    const stickyPrice = bar.querySelector('.dv-sticky-atc__price');
    const stickyButton = bar.querySelector('.dv-sticky-atc__button');

    const sync = () => {
      const priceNow = document.querySelector('[id^="price-"] .price, .product__info-container .price') || firstPrice;
      const visiblePrice = Array.from(priceNow.querySelectorAll('.price-item')).find(
        (item) => item.offsetWidth || item.offsetHeight
      );
      stickyTitle.textContent = title.textContent.trim();
      stickyPrice.textContent = (visiblePrice || priceNow).textContent.replace(/\s+/g, ' ').trim();
      stickyButton.textContent = mainButton.textContent.replace(/\s+/g, ' ').trim() || 'Setja í körfu';
      stickyButton.disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
    };

    stickyButton.addEventListener('click', () => {
      if (!stickyButton.disabled) mainButton.click();
    });

    const updateVisibility = () => {
      const rect = mainButton.getBoundingClientRect();
      bar.dataset.visible = String(window.matchMedia(MOBILE_QUERY).matches && rect.bottom < 0);
    };

    new IntersectionObserver(updateVisibility, { threshold: 0.05 }).observe(mainButton);
    let scrollFrame = 0;
    window.addEventListener('scroll', () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(() => {
        scrollFrame = 0;
        updateVisibility();
      });
    }, { passive: true });

    new MutationObserver(sync).observe(mainButton, { attributes: true, childList: true, subtree: true });
    const priceWrapper = firstPrice.closest('[id^="price-"]') || firstPrice.parentElement || firstPrice;
    new MutationObserver(sync).observe(priceWrapper, { childList: true, subtree: true });
    window.matchMedia(MOBILE_QUERY).addEventListener('change', updateVisibility);
    sync();
    updateVisibility();
  }

  function init(root = document) {
    document.body.dataset.dvSafeCore = 'ready';
    initStickyPurchaseBar(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
